import React from "react";
import Marty from "marty";

let StyleGuide = React.createClass({
    render() {
        return (
            <section className="eo-view style-guide">
                <h1 className="eo-h1">Style Guide</h1>
                <hr/>

                <h2 className="eo-h2">Colors</h2>
                <div className="color-block blue">
                    <p>$eo-blue</p>
                    <p>#23b8eb</p>
                </div>
                <div className="color-block black">
                    <p>$eo-black</p>
                    <p>#1d262b</p></div>
                <div className="color-block gray-3">
                    <p>$eo-gray-3</p>
                    <p>#373d40</p>
                </div>
                <hr/>

                <h2 className="eo-h2">Headers</h2>
                <h1 className="eo-h1">Hero headlines (.eo-h1)</h1>
                <h2 className="eo-h2">Section headlines  (.eo-h2)</h2>
                <h3 className="eo-h3">Sub headlines  (.eo-h3)</h3>
                <hr/>

                <h2 className="eo-h2">Paragraph</h2>
                <p>No class necessary because this is the base style for all copy on the site.</p>
                <p>Four loko twee cardigan craft beer, chillwave mlkshk butcher Marfa lomo Vice Shoreditch polaroid American Apparel leggings Pitchfork. Sustainable try-hard Echo Park VHS authentic jean shorts, banh mi Shoreditch bespoke stumptown disrupt. Paleo Bushwick Kickstarter jean shorts Neutra YOLO master cleanse, Blue Bottle blog. Williamsburg blog Vice, locavore leggings vegan pickled tousled sustainable Echo Park yr ennui. Tilde Etsy try-hard, umami fanny pack cold-pressed bespoke ethical Schlitz typewriter flannel. Mixtape direct trade migas, fixie slow-carb banjo DIY sartorial swag. Bitters four loko semiotics, meggings whatever kale chips wolf locavore.</p>
                <hr/>

                <h2 className="eo-h2">Nav Links</h2>
                <a href="#" className="eo-link-nav">Home (.eo-h2)</a>{` `}
                <a href="#" className="eo-link-nav">Home</a>{` `}
                <a href="#" className="eo-link-nav">Home</a>{` `}
                <hr/>
            </section>
        );
    },
    getInitialState() {
        return {};
    }
});

export default Marty.createContainer(StyleGuide, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/sg/Handler.js
 **/